import { Box } from "@mui/material";
import DynamicTable from "../../../data/DynamicTable/dynamicTable";

import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { useEffect, useState } from "react";
import {
  fetchDataEngine,
  graphqlQuery,
} from "../../../data/Axios/DynamicService";

import {
    AllEmployeesQuery,
  employeeLeaveBalances,
  leaveApplications,
  leaveApplicationsByUser,
} from "../../../data/Queries/HRmanagement/leavemanagement";
import { EmployeeColumns, LeaveApplicationsColumns } from "../../../data/Columns/hrmanagement";
import { HRService } from "../../../config";
import LeaveApplicationForm from "./form";
import { tokens } from "../../../theme";
import { useTheme } from "@emotion/react";
import EmployeeCreationForm from "./form";

const base_url = HRService.uri;

const EmployeesTable = () => {
  const actions = {
    entity: "My Leave Applications",
    isSubRight: true,
    edit: {
      key: "EDIT",
      button_name: "Edit",
      Show_Button: true,
      permission: "EditPermission",
    },
    add: {
      key: "ADD",
      button_name: "Add",
      Show_Button: true,
      permission: "CreatePermission",
      inputObjectName: "createCaseDynamic",
      InputObject: "newCase",
    },
    activateDeactivate: {
      key: "ACTIVATEDEACTIVATE",
      button_name: "Deactivate",
      Show_Button: false,
      permission: "ActivatePermission",
    },
    AssignTask: {
      key: "ASSIGN_TASK",
      button_name: "Assign Task",
      Show_Button: false,
      permission: "hasNoPermission",
      roleGroupId: [1, 2, 3, 4],
    },
    ViewEmployeeDetails: {
    key: "VIEWDETAILS",
    button_name: "View Details",
    Show_Button: true,
    permission: "hasNoPermission",
    roleGroupId: [1, 2, 3, 4],
  },
  PrintEmployeePayslip:{ 
      key: "PRINTPAYSLIP", 
      button_name: "Print Payslip", 
      Show_Button: true, 
      permission: "hasNoPermission", 
      roleGroupId: [1, 2, 3, 4], 
    },

    showStatus: true,
  };
  const [data, setData] = useState([]);
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  useEffect(() => {
    let isMounted = true;

    async function fetchLeaveBalances() {
      try {
        const response = await graphqlQuery(employeeLeaveBalances, base_url);
        if (response) {
          setData(response);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }

    fetchLeaveBalances();

    return () => {
      isMounted = false;
    };
  }, []);
 
  return (
    <Box m="2px">
      <>
        <Box
          sx={{
            alignItems: "center",
            display: "flex",
            justifyContent: "center",
          }}
        >
          
        </Box>
        <DynamicTable
          title="All Employees"
          subtitle="View all Employees, create or update a employee"
          columns={EmployeeColumns}
          FormComponent={EmployeeCreationForm}
          query={AllEmployeesQuery}
          actions={actions}
          base_url={base_url}
        />
      </>
    </Box>
  );
};

export default EmployeesTable;
